import HeaderBackgroundImage from "./assets/images/HeaderBackgroundImage.jpg";
import { Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function TopSection() {
  return (
    <section id="home" className="hero" aria-labelledby="hero-title">
      <img className="hero-photo" src={HeaderBackgroundImage} alt="" />
      <div className="hero-shade" />
      <div className="hero-content">
        <h1 id="hero-title">
          <span className="hero-access">24/7</span>{" "}
          <span>POSITIVE NRG</span>{" "}
          <span>GYM</span>
        </h1>
        <p className="hero-benefits">NO JOINING FEES - NO CONTRACTS</p>
        <p className="hero-price"><strong>$349</strong> FOR 12 MONTHS</p>
        <div className="hero-actions">
          <Button href="#join" variant="contained" endIcon={<ArrowForwardIcon />}>
            Join now
          </Button>
          <Button href="#pricing" variant="outlined">View pricing</Button>
        </div>
        <p className="hero-location">Lota, QLD</p>
      </div>
    </section>
  );
}

export default TopSection;
